var moduleSlider = (function(){

	'use strict';

	var timeoutRef = null;
	var currentActiveSlide = null;

	function init(){		


		currentActiveSlide = document.querySelector('.slide.active.block');

		let bullets = document.querySelectorAll(".slider-bullet");

		bullets.forEach(function(bullet) {
			bullet.addEventListener("click",function(e){
				let activeSlide = document.querySelector('.slide.active')
				let activeBullet = document.querySelector('.slider-bullet.active')
				let newActiveSlide = document.querySelector("#"+e.currentTarget.attributes["data-target"].value);
				if (newActiveSlide && newActiveSlide.id != activeSlide.id){
					if(activeBullet){activeBullet.classList.remove("active");}
					if (activeSlide){
						activeSlide.classList.remove("active","transient");
					}
					newActiveSlide.classList.add("active");
					if (newActiveSlide.id !== currentActiveSlide.id){
						newActiveSlide.classList.add("transient");
					}
					armSlideBlock(newActiveSlide);
				}
				e.currentTarget.classList.add("active");
			})
		});

		let arrows = document.querySelectorAll(".slider-arrow");

		arrows.forEach(function(arrow) {
			arrow.addEventListener("click",function(e){
				let activeSlide = document.querySelector('.slide.active');
				let activeBullet = document.querySelector('.slider-bullet.active');
				if ( null !== activeSlide){
					activeSlide.classList.remove("active");
				}
				if( null !== activeBullet){
					activeBullet.classList.remove("active");
				}

				let newActiveSlideId = activeSlide.attributes["data-next"].value;
				if (e.currentTarget.classList.contains("left")){
					newActiveSlideId = activeSlide.attributes["data-prev"].value;
				}
				let newActiveSlide = document.querySelector('#'+newActiveSlideId);
				if (newActiveSlide){
					newActiveSlide.classList.add("active","transient");
					armSlideBlock(newActiveSlide);
					let newBullet = document.querySelector("#bullet-"+newActiveSlideId);
					if (newBullet){
						newBullet.classList.add("active");
					}
				}
			})
		});	

	}

	function armSlideBlock(newActiveSlide){
		clearTimeout(timeoutRef);
		timeoutRef = setTimeout(function(){
			currentActiveSlide.classList.remove("block");
			currentActiveSlide = newActiveSlide;
			currentActiveSlide.classList.add("block","active");
			document.querySelectorAll('.slide.transient').forEach(elt => elt.classList.remove("transient"));
			if ( 0 < currentActiveSlide.querySelectorAll(".online_3d_viewer").length && 0 == currentActiveSlide.querySelectorAll("#viewer").length){
				if (OV !== null && OV !== undefined){
					OV.Init3DViewerElements();
				}
			}
		},500);
	}

	return {
		init: init,
	};
})();

window.addEventListener('load', initAscending);
window.addEventListener('resize', initAscending);

function initAscending(e){

	const HEIGHT_WIDTH_RATIO = 0.5625;
	const breapoint_resolution = 992;

	let galery = document.querySelector('.css-gal');
	if (galery != null){
		moduleSlider.init();
	}

	if ( window.innerWidth > breapoint_resolution){

		let planTemplate = document.querySelector('.single-plan');

		if (planTemplate){
			let cssGal = document.querySelector('.css-gal');
			let sidePart = document.querySelector('.ascending-part');
			let maxHeights = (window.innerHeight - ( document.querySelector('.site-header').offsetHeight + document.querySelector('.site-header').offsetTop ) ) + 'px';
			cssGal.style.maxHeight = maxHeights;
			sidePart.style.maxHeight = maxHeights;
			setTimeout(function(){
				let sidePart = document.querySelector('.ascending-part');
				sidePart.style.maxHeight = window.getComputedStyle( document.querySelector('.slide.active.block')).height;
			}, 600);
		}

		
		let tutoTemplate = document.querySelector('.single-tutorial');
		if (tutoTemplate){
			let videoContainer = document.querySelector('.video-container');
			setTimeout(function(){
				let sidePart = document.querySelector('.ascending-part');
				sidePart.style.maxHeight = window.getComputedStyle( videoContainer).height;
			},600);
		}
	}
};

// window.addEventListener ('load', () => {
//     // init all viewers on the page
// 	if ( OV !== undefined && OV !== null ){
//     	OV.Init3DViewerElements ();
// 	}
// });